<template>
  <div>
    <common-dialog ref="dialog" width="1100px" unit="存货档案" edit-title id-key="ProductId" :data="data" :line-form="true" form-label-width="110px" :form-rules="rules"
      :save-func="() => {}" @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="18">
            <el-row>
              <el-col :span="12">
                <el-form-item label="存货编码" prop="ProductNo">
                  <span v-if="Mode == 0" class="detail-span">{{
                    data.ProductNo
                  }}</span>
                  <el-input v-else v-model="data.ProductNo" placeholder="请输入类别编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="存货名称" prop="ProductName">
                  <el-input v-model="data.ProductName" placeholder="请输入存货名称" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('ShortName')">
                <el-form-item label="简称">
                  <el-input v-model="data.ShortName" placeholder="请输入简称" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('ProductSpec')">
                <el-form-item label="规格型号" prop="ProductSpec">
                  <el-input v-model="data.ProductSpec" placeholder="请输入规格型号" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="存货分类" prop="ClassId">
                  <tree-select ref="treeSelect" @input="nodeSelect" :value="data.ClassId" />
                  <!-- <el-select v-model="data.ClassId">
                    <el-option
                      v-for="item in classList"
                      :key="item.ClassId"
                      :value="item.ClassId"
                      :label="item.ClassName"
                    >
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计价方式" prop="ValuationId">
                  <el-select v-model="data.ValuationId" :disabled="IsExistStatus">
                    <el-option v-for="item in valuationList" :key="item.ValuationId" :value="item.ValuationId" :label="item.ValuationName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="4" :offset="2">
            <div style="height: 148px" class="flex">
              <el-image style="width: 148px; height: 148px" :src="url" :preview-src-list="urls">
                <div slot="error" class="flex" style="background: #f0f0f0; width: 100%; height: 100%">
                  <i style="width: 100%; height: 100%" class="el-icon-picture-outline flex"></i>
                </div>
              </el-image>
            </div>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName">
          <el-tab-pane label="基础信息" name="tab1">
            <el-row class="border">
              <el-col :span="12">
                <el-form-item label="会计类型" prop="ProductType">
                  <el-select v-model="data.ProductType" @change="changeProductType">
                    <el-option v-for="item in productTypeList" :key="item.ProductTypeId" :value="item.ProductTypeId" :label="item.ProduceTypeName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="加工阶段" prop="ProcessStage">
                  <el-select v-model="data.ProcessStage" @change="changeProcessStage">
                    <el-option :value="0" label="无"></el-option>
                    <el-option :value="1" label="注塑"></el-option>
                    <el-option :value="2" label="配件"></el-option>
                    <el-option :value="3" label="装配"></el-option>
                    <el-option :value="4" label="组合"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="存货属性" prop="Property">
                  <el-select v-model="Property" @change="isProperty" :multiple="isMultiple">
                    <el-option value="销售" label="销售"></el-option>
                    <el-option value="采购" label="采购"></el-option>
                    <el-option value="加工" label="加工"></el-option>
                    <el-option value="耗用" label="耗用"></el-option>
                    <el-option value="劳务" label="劳务"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- ? -->
              <el-col :span="12">
                <el-form-item label="批号管理" prop="BatchNumber">
                  <el-select v-model="data.BatchNumber" :disabled="IsExistStatus">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用颜色" prop="UseColor">
                  <el-select v-model="data.UseColor" :disabled="IsExistStatus">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用特殊加工" prop="UseProcess">
                  <el-select v-model="data.UseProcess" :disabled="true">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启动存货状态" prop="ProductStatusId">
                  <!-- @change="mouldChange"  <status-select v-model="data.ProductStatusId"  />-->
                  <el-select v-model="data.ProductStatusId" :disabled="IsExistStatus">
                    <el-option :value="1" label="是"></el-option>
                    <el-option :value="0" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="保质期" prop="HasExpire">
                  <el-select v-model="data.HasExpire" @change="isHasExpire" :disabled="IsExistStatus">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('Rate')">
                <el-form-item label="税率%">
                  <el-input type="number" v-model="data.Rate" placeholder="请输入税率%" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="保质天数" :prop="isExpireDay ? 'ExpireDay' : ''">
                  <el-input type="number" v-int v-model="data.ExpireDay" placeholder="请输入保质天数" :disabled="!isExpireDay" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('GoldenTaxCode')">
                <el-form-item label="金税分类编码">
                  <el-input v-model="data.GoldenTaxCode" placeholder="请输入金税分类编码" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="品牌">
                  <el-input type="text" v-model="data.Brand" placeholder="请输入品牌" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('NetWeight')">
                <el-form-item label="净重">
                  <el-input type="number" v-model="data.NetWeight" placeholder="请输入净重" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('GrossWeight')">
                <el-form-item label="毛重">
                  <el-input type="number" v-model="data.GrossWeight" placeholder="请输入毛重" />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12" v-if="iShow('Mould')">
                <el-form-item label="每模数">
                  <el-input
                    type="number"
                    v-model="data.Mould"
                    placeholder="请输入每模数"
                  />
                </el-form-item>
              </el-col> -->
              <el-col :span="12" v-if="iShow('Volume')">
                <el-form-item label="体积">
                  <el-input type="number" v-model="data.Volume" placeholder="请输入体积" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="重量单位">  
                  <el-input type="text" v-model="data.WeightUnit" placeholder="请输入重量单位" />
                  <!-- <el-select v-model="data.WeightUnitId">
                    <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12" v-if="iShow('MouldId')">
                <el-form-item label="模号">
                  <el-select v-model="data.MouldId">
                    <el-option
                      v-for="item in MouldList"
                      :key="item.MouldId"
                      :value="item.MouldId"
                      :label="item.MouldName"
                      @click.native="getAfew(item)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

              <!-- <el-col :span="12" v-if="iShow('MouldRubberId')">
                <el-form-item label="1出几套">
                  {{ data.MouldRubberId }}
                </el-form-item>
              </el-col> -->

              <el-col :span="12" v-if="iShow('DefaultWarehouse')">
                <el-form-item label="生产类型" label-width="110px" :prop="isNotProductNature ? '' : 'ProductNature'">
                  <el-select v-model="data.ProductNature">
                    <el-option :value="0" label="自制"></el-option>
                    <el-option :value="1" label="委外"></el-option>
                    <el-option :value="2" label="自制&委外"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态" prop="Status">
                  <el-select v-model="data.Status">
                    <el-option :value="1" label="启用"></el-option>
                    <el-option :value="0" label="停用"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="建档人">
                  {{ this.$commonJs.userName() }}
                  <!-- <el-input v-model="data.AddUserName" placeholder="请输入建档人名称" /> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="建档日期">
                  {{ $commonJs.toDateString(data.AddTime) }}
                  <!-- {{this.$commonJs.getToday(data.AddTime)}} -->
                  <!-- <el-date-picker v-model="data.AddTime" type="date" placeholder="选择日期" value-format="YYY-MM-DD" disabled>
              </el-date-picker> -->
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isEdit">
                <el-form-item label="修改人">
                  {{ this.$commonJs.userName() }}
                  <!-- <el-input v-model="data.UpdateUserName" placeholder="请输入修改人名称" /> -->
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isEdit">
                <el-form-item label="修改日期">
                  {{ this.$commonJs.getToday(data.UpdateTime) }}
                  <!-- <el-date-picker v-model="data.UpdateTime" type="date" placeholder="选择日期" value-format="YYY-MM-DD" disabled>
              </el-date-picker> -->
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="Remark">
                  <el-input v-model="data.Remark" type="textarea" class="border" />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="row-head">计量单位</div>
            <el-row class="border">
              <el-col :span="12">
                <el-form-item label="计量方式" prop="UnitType">
                  <el-select v-model="data.UnitType" @change="unitToggle" :disabled="IsExistStatus" ref="UnitType">
                    <el-option :value="0" label="单计量"></el-option>
                    <el-option :value="1" label="多计量"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-if="is_moreGroup" label="计量单位组" :prop="is_moreGroup ? 'UnitGroupId' : ''">
                  <el-select v-model="data.UnitGroupId" @change="unitGroupToggle" :disabled="IsExistStatus">
                    <el-option v-for="item in unitGroup" :key="item.UnitGroupId" :value="item.UnitGroupId" :label="item.Name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="报表辅单位" prop="RpUnitId">
                  <el-select v-model="data.RpUnitId" @change="singToggle">
                    <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="库存常用单位" prop="SkUnitId">
                  <el-select v-model="data.SkUnitId" @change="singToggle">
                    <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采购常用单位" prop="PuUnitId">
                  <el-select v-model="data.PuUnitId" @change="singToggle">
                    <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售常用单位" prop="SaUnitId">
                  <el-select v-model="data.SaUnitId" @change="singToggle">
                    <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="生产常用单位" prop="PdUnitId">
                      <el-select v-model="data.PdUnitId" @change="singToggle">
                        <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="单位列表" name="tab2">
            <div class="row-head">单位列表</div>
            <div v-if="showGrammage">
              <el-row>
                <el-col :span="4">
                  <el-form-item label="启用克重" class="notBottom" >
                    <el-checkbox @change="changeHasGrammage(data)" v-model="data.HasGrammage">
                    </el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <span style="color:red;">注:只有胶件类型，多计量浮动单位，且浮动单位为重量单位，才可启用</span>
                </el-col>
                <el-col :span="24" v-if="hasGrammage">
                 <el-row>
                  <el-col :span="6">
                  <el-form-item label="克重" >
                    <el-input type="number" v-model="data.Grammage" @change="changeRate(data)" placeholder="请输入克重" />
                  </el-form-item></el-col>
                  <el-col :span="6">
                  <el-form-item label="计算变量" >
                    <el-input type="number" v-model="data.Variable" @change="changeRate(data)" placeholder="请输入变量" />
                  </el-form-item></el-col>
                  <el-col  :span="12"> 
                    <span style="padding-left: 20px;">示例：当浮动单位为斤时，填写500含义为1斤=500克</span><br>
                    <span style="padding-left: 20px;">计算公式：换算率=计算变量/克重</span>
                  </el-col>
                 </el-row>
                </el-col>
              </el-row>
            </div>
            <el-table ref="table" v-if="is_showUnitGroup" class="table-line tb-c-head" :data="unitGroupList" border>
              <el-table-column prop="Name" label="计量单位组" min-width="110" align="center" />
              <el-table-column prop="UnitName" label="计量单位" min-width="80" align="center" />
              <el-table-column prop="IsMain" label="主计量" min-width="80" align="center">
                <template slot-scope="{ row, $index }">
                  <el-checkbox @change="mainUnitToggle(data, $index)" v-model="row.IsMain" :disabled="true">
                  </el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="ChangeType" label="换算类型" min-width="80" align="center">
                <template slot-scope="{ row }">
                  <span v-if="row.IsMain"></span>
                  <span v-else-if="row.ChangeType == 1">浮动</span>
                  <span v-else-if="row.ChangeType == 0">固定</span>
                </template>
              </el-table-column>
              <el-table-column prop="Rate" label="换算率" min-width="80" align="center">
                <template slot-scope="{ row, $index }">
                  <template v-if="row.IsMain != true">
                    <el-input class="rate" type="number" v-model="row.Rate" :disabled="row.ChangeType === 0" @change="upDateRate($event, $index, row)">
                    </el-input>
                  </template>
                  <template v-else>
                    <span>{{ row.Rate }}</span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column label="换算说明" min-width="180" align="center" show-overflow-tooltip>
                <template slot-scope="{ row }">
                  <span>{{ row.RateDescription }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="颜色列表" name="tab3">
            <div class="row-tb-head">
              <div style="float: left">颜色组</div>
              <div style="float: right">
                <el-button type="primary" @click="add" :disabled="!data.UseColor">添加</el-button>
                <el-button type="danger" @click="del">删除</el-button>
              </div>
            </div>
            <el-table ref="table" class="table-line tb-c-head" :data="colorGroup" @selection-change="handleSelectionChange" border>
              <el-table-column type="selection" width="55" />
              <el-table-column prop="Sn" label="序号" min-width="70" align="center"></el-table-column>
              <el-table-column prop="ClassName" label="颜色类别" min-width="80" align="center"></el-table-column>
              <el-table-column prop="ClassNo" label="颜色编号" min-width="100" align="center"></el-table-column>
              <el-table-column prop="ColorName" label="颜色名称" min-width="110" align="center"></el-table-column>
              <el-table-column prop="ColorName" label="状态" width="90" align="center">
                <template slot-scope="{row}">
                  <el-tag type="success" v-if="row.Status==1">启用</el-tag>
                  <el-tag type="danger" v-else>停用</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="库存信息" name="tab4">
            <el-row>
              <el-col :span="12" v-if="iShow('MinStock')">
                <el-form-item label="最低库存">
                  <el-input type="number" v-model="data.MinStock" placeholder="请输入最低库存" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('MaxStock')">
                <el-form-item label="最高库存">
                  <el-input type="number" v-model="data.MaxStock" placeholder="请输入最高库存" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('SafetyStock')">
                <el-form-item label="安全库存">
                  <el-input type="number" v-model="data.SafetyStock" placeholder="请输入安全库存" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('DefaultWarehouse')">
                <el-form-item label="默认仓库">
                  <el-select v-model="data.DefaultWarehouse" clearable>
                    <el-option v-for="item in warehouseList" :key="item.WarehouseId" :value="item.WarehouseId" :label="item.WarehouseName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('DefaultSupplier')">
                <el-form-item label="默认供应商">
                  <el-select v-model="data.DefaultSupplier" clearable>
                    <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('LeadTime')">
                <el-form-item label="采购周期(天)">
                  <el-input type="number" oninput="value=value.replace(/[^\d]/g,'')" v-model="data.LeadTime" placeholder="请输入采购周期" />
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="iShow('OrderType')">
                <el-form-item label="订货类型">
                  <el-select v-model="data.OrderType" clearable>
                    <el-option v-for="item in [{label: '按单订货', value: 1}, {label: '按库存订货', value: 2}]" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="模具列表" name="tab5">
            <div class="row-tb-head" v-show="isMouldTabShow">
              <div style="float: left">模具组</div>
              <div style="float: right">
                <el-button type="primary" @click="addMould">添加</el-button>
                <el-button type="danger" @click="delMould">删除</el-button>
              </div>
            </div>
            <el-table v-show="isMouldTabShow" ref="table" class="table-line tb-c-head" :data="Rubbers" @selection-change="handleMouldChange" border>
              <el-table-column type="selection" width="55" />
              <el-table-column label="序号" prop="Sn" min-width="70" align="center"></el-table-column>
              <el-table-column prop="MouldName" label="模具名称" min-width="160" align="center">
                <template slot-scope="{ row }">
                  <el-select v-model="row.MouldName" @change="changeMouldName($event, row)" filterable>
                    <el-option v-for="item in MouldList" :key="item.MouldId" :label="item.MouldName" :value="item.MouldId"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="MouldNo" label="模具编号" min-width="100" align="center"></el-table-column>
              <el-table-column prop="Afew" label="1出几套" min-width="110" align="center"></el-table-column>
              <el-table-column Prop="Quantity" label="数量" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-input placeholder="输入数量" v-model="row.Quantity" @change="editT(row)" />
                </template>
              </el-table-column>
              <el-table-column prop="Weight" label="单重" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-input placeholder="输入单重" v-model="row.Weight" @change="editT(row)" />
                </template>
              </el-table-column>
              <el-table-column prop="PerGrossWeightUnitName" label="重量单位" min-width="110" align="center">
              </el-table-column>
              <el-table-column label="是否默认" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <span>{{ row.IsDefault ? '默认' : '' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-button type="text" @click="setMouldDefault(row)">设置默认</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="图片" name="tab6">
            <el-row>
              <el-col :span="24">
                <el-form-item label="图片" class="notBottom" prop="ImgUrl">
                  <el-upload class="file-up" :http-request="httpRequest" :before-upload="beforeUploadHandler" ref="uploadImg" action="#" list-type="picture-card"
                    :show-file-list="true" accept=".jpg,.png,.jpeg" :on-exceed="masterFileMax" :limit="3" :file-list="ImgUrl">
                    <i class="el-icon-plus plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <el-image style="width: 148px; height: 148px" :src="file.url" fit="fill"></el-image>
                      <label class="el-upload-list__item-status-label" v-if="file.isDefault">
                        <i :class="{'el-icon-upload-success': true,'el-icon-check': true}"></i>
                      </label>
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file.url)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="handleSetDefault(file)">
                          <i class="el-icon-check"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click="picRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave()">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <color-dialog ref="colorDialog" in-dialog selectable multiple @select-multiple="setColor"></color-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import colorDialog from "@/components/basedata/inventory/color/listDialog";
import statusSelect from "@/components/basedata/inventory/status/select";
import treeSelect from "@/components/basedata/inventory/types/select1";
import * as imageConversion from 'image-conversion'
import xTableColumnVue from '@/components/common/xTableColumn.vue';
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    colorDialog,
    statusSelect,
    treeSelect,
  },
  computed: {
    isNotProductNature() {

      // console.log('this.data.ProcessStage', this.data.ProcessStage === 0)
      // console.log('Array.isArray(this.isProperty)', Array.isArray(this.isProperty))
      // console.log('this.isProperty.includes', this.isProperty)


      // console.log('isNotProductNature', this.data.ProcessStage === 0 && Array.isArray(this.isProperty) && this.isProperty.includes('采购'))
      return this.data.ProcessStage === 0 && Array.isArray(this.Property) && this.Property.includes('采购')
    },
    host() {
      // console.log(window.location.origin)
      return window.location.origin;
    },
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
    isDisabled() {
      if (this.data.ProcessStage === 0 && (this.Property && Array.isArray(this.Property) && this.Property.includes('采购'))) {
        return true
      } else {
        return false
      }
    },
    showGrammage(){
      var check=this.unitGroupList.filter(x=> x.ChangeType==1&&x.IsMain!=true)
 
      return this.data.ProductType==2&&this.data.UnitType==1&&check.length>0;
    }
  },
  data() {
    return {
      activeName: "tab1", // 默认显示的页签
      baseFiles: [],
      ImgUrl: [],
      removeImgUrl: [],
      // headers: { Authorization: "" },
      dialogImageUrl: "",
      dialogVisible: false,
      isMultiple: true,
      is_showUnitGroup: true,
      Property: null,
      IsExistStatus: false,
      selectMouldList: [], // 多选模具
      deleteMouldList: [], // 存放被删除的模具
      isMouldTabShow: true, // 模具列表标签内容是否显示
      ProduceTypeName: "", // 当前的存货类型
      url: "", // 默认图片
      urls: [], // 图片列表
      requiredRubbers: false, // 模具列表是否必填
      unitParams: {
        UnitGroupId: null,
        IsGroup: false,
      },
      hasGrammage:false,
      data: {
        ProductId: 0,
        ProductNo: "",
        ProductName: "",
        ShortName: "",
        ProductSpec: "",
        ClassId: null,
        ValuationId: 1,
        ImgUrl: "",
        // ValuationId: null,
        ProductType: null,
        ProcessStage: null,
        Property: null,
        BatchNumber: false,
        UseColor: null,
        UseProcess: false,
        ProductStatusId: 0,
        HasExpire: false,
        Rate: "",
        ProductNature: null,
        ExpireDay: null,
        GoldenTaxCode: "",
        LeadTime: null,
        MinStock: null,
        MaxStock: null,
        SafetyStock: null,
        NetWeight: null,
        GrossWeight: null,
        Mould: null,
        Volume: null,
        MouldId: null,
        MouldRubberId: "",
        DefaultSupplier: null,
        DefaultWarehouse: null,
        WeightUnitId: null, // 重量单位

        // 计量单位
        UnitType: 0,
        UnitGroupId: null,
        RpUnitId: null,
        SkUnitId: null,
        PuUnitId: null,
        SaUnitId: null,
        PdUnitId: null,
        Status: 1,
        AddUserName: "",
        AddUserId: null,
        AddTime: "",
        UpdateUserId: "",
        UpdateUserName: "",
        UpdateTime: "",
        Remark: "",
        Colors: [],
        Units: [],
        Rubbers: [],
        HasGrammage:false,
        Grammage:null,
        Variable:null
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      // 分类
      classApi: require("@/api/ba/class").default,
      //存货分类<!-- 可能需要补充参数 -->
      class2Api: require("@/api/sy/dictionary").default,
      //计价方式
      valuationApi: require("@/api/ba/valuation").default,
      //存货类型
      productTypeApi: require("@/api/ba/productType").default,
      //计量单位
      formApi: require("@/api/sy/formSetting").default,
      // 模具档案
      mouldApi: require("@/api/ba/mould").default,
      // 默认供应商
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      // 默认仓库
      warehouseApi: require("@/api/ba/warehouse").default,
      // 单位
      unitApi: require("@/api/ba/unit").default,
      // 计量单位
      unitGroupApi: require("@/api/ba/unitGroup").default,
      api: require("@/api/ba/product").default,
      isEdit: false,
      is_moreGroup: false,
      isExpireDay: false,
      MouldList: [],
      WeightUnitIds: [], // 重量单位列表
      Rubbers: [], // 模具信息列表
      tradeUnitList: [],
      warehouseList: [],
      unitList: [],
      classList: [],
      valuationList: [],
      productTypeList: [],
      showList: [],
      unitGroup: [],
      multipleSelection: [],
      // unitList: [],
      colorGroup: [],
      unitGroupList: [],
      // PreColor: [],
      // PreUnits: [],
      // PreUnitGroupList: [],
      // PreColorGroup: [],
      is_ColorSaved: false,
      is_UnitSaved: false,
      rules: {
        ProductNo: [{ required: true, message: "请输入存货编码" }],
        ProductName: [{ required: true, message: "请输入存货名称" }],
        ClassId: [{ required: true, message: "请选择存货分类" }],
        ValuationId: [{ required: true, message: "请选择计价方式" }],
        ProductType: [{ required: true, message: "请选择存货类型" }],
        ProcessStage: [{ required: true, message: "请选择加工阶段" }],
        Property: [
          { required: true, message: "请选择存货属性", trigger: "blur" },
        ],
        BatchNumber: [{ required: true, message: "请选择批号管理" }],
        UseColor: [{ required: true, message: "请选择启用颜色" }],
        UseProcess: [{ required: true, message: "请选择启用特殊加工" }],
        ProductStatusId: [{ required: true, message: "请选择存货状态" }],
        HasExpire: [{ required: true, message: "请选择保质期" }],

        UnitType: [{ required: true, message: "请选择计量方式" }],
        // UnitGroupId: [
        //   { required: true, message: "请选择计量单位组", trigger: "blur" },
        // ],
        UnitGroupId: [
          { required: true, message: "请选择计量单位组", trigger: "blur" },
        ],
        RpUnitId: [
          { required: true, message: "请选择报表辅单位", trigger: "blur" },
        ],
        SkUnitId: [
          { required: true, message: "请选择库存常用单位", trigger: "blur" },
        ],
        // PuUnitId: [
        //   { required: true, message: "请选择采购常用单位", trigger: "blur" },
        // ],
        // SaUnitId: [
        //   { required: true, message: "请选择销售常用单位", trigger: "blur" },
        // ],
        // PdUnitId: [
        //   { required: true, message: "请选择生产常用单位", trigger: "blur" },
        // ],
        Status: [{ required: true, message: "请选择状态" }],
        ExpireDay: [{ required: true, message: "保质天数不能为空", trigger: "blur" }],
        ProductNature: [{ required: true, message: "生产类型不能为空" }],
      },
    };
  },
  mounted() {
    console.log('this.$refs', this.$refs.dialog.$refs)
  },
  methods: {
    changeRate(data){
      if(data.Grammage&&data.Variable){
          console.log(Number((data.Variable/data.Grammage).toFixed(4)),"aa");
        let isMainItem = this.unitGroupList.filter(item => {
          return item.IsMain === true;
        })[0]
        this.unitGroupList.forEach((x)=>{
            if(x.IsMain==false){
              if (x.T === 3) x.T = 1;
              x.Rate=Number((data.Variable/data.Grammage).toFixed(4));
              x.RateDescription="1"+x.UnitName+"="+x.Rate+isMainItem.UnitName
            }

        })

      }
    },
    changeHasGrammage(data){
      this.hasGrammage=data.HasGrammage;
    },

    base64ToFile(dataurl, filename) {
      //将base64转换为文件
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    fileToBase64(data) {
      return new Promise((resolve, reject) => {
        let rd = new FileReader(); // 创建文件读取对象
        rd.readAsDataURL(data); // 文件读取装换为base64类型
        rd.onload = (e) => {
          resolve(e.currentTarget.result);
          // _this.base64Url = this.result;
          // console.log(_this.ImgUrl);
        };
      });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    dealImage(base64, callback) {
      var newImage = new Image();
      var quality = 1; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function () {
        console.log('newImage', [newImage]);
        // if (newImage.width * newImage.height >= 10000) {
        //   //获取原图片20%的宽高
        //   imgWidth = (newImage.width * 0.20).toFixed(0);
        //   imgHeight = (newImage.height * 0.20).toFixed(0);
        // } else {
        //   imgWidth = (newImage.width).toFixed(0);
        //   imgHeight = (newImage.height).toFixed(0);
        // }
        imgWidth = newImage.width;
        imgHeight = newImage.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        console.log('wh', imgWidth, imgHeight);
        canvas.width = imgWidth;
        canvas.height = imgHeight;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        // quality = 0.9;
        // var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        // console.log("??!-*",base64.length)
        // 如想确保图片压缩到自己想要的尺寸,如要求小于200kb，请加以下语句，quality初始值根据情况自定
        while ((base64.length * 0.75) / 1024 > 200) {
          quality -= 0.1;
          base64 = canvas.toDataURL("image/jpeg", quality);
          // console.log("压缩")
        }
        callback(base64); //必须通过回调函数返回，否则无法及时拿到该值
      };
    },
    beforeUploadHandler(file) {
      // if (file.size / 1024 > 500) {
      //   this.$message.warning('上传头像图片大小不能超过 500KB!');
      //   return false;
      // }
      var _this = this;
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader();
          // 将文件加载进入
          reader.readAsDataURL(file);
          reader.onload = function (e) {
            var base64 = reader.result;
            console.log("原", (base64.length * 0.75) / 1024);
            _this.dealImage(base64, function (new_base64) {
              console.log("后", (new_base64.length * 0.75) / 1024);
              var new_file = _this.dataURLtoFile(new_base64, file.name);
              console.log("new_file", new_file);
              resolve(new_file);
            });
          };
        } catch (error) {
          reject(error);
        }
      });
    },
    // //把图片文件作为参数传递到方法中
    // beforeAvatarUpload(file) {
    //   const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    //   if (!isJpgOrPng) {
    //     console.log('上传头像图片只能是 JPG 或 PNG 格式!');
    //     return false;
    //   }
    //   return new Promise((resolve) => {
    //     // 压缩到100KB,这里的100就是要压缩的大小,可自定义
    //     imageConversion.compressAccurately(file, 200).then(res => {
    //       console.log(res)
    //       resolve(res);
    //     });
    //   })
    // },
    // async toFile(file) {
    //   let res = await this.beforeAvatarUpload(file)
    //   console.log('图片 res', res)
    //   const imgBlob = URL.createObjectURL(file);

    //   return imgBlob;
    // },
    fileToBlob(file) {
      const imgBlob = URL.createObjectURL(file);
      return imgBlob;
    },
    async httpRequest(data) {
      console.log('data.file 前 =====', data.file)
      data.file.T = 0;
      data.file.ProductImgId = 0;
      data.file.ProductId = 0;
      data.file.url = this.fileToBlob(data.file);
      data.file.isDefault = false;
      if (this.ImgUrl.length < 1) {
        data.file.isDefault = true;
        this.ImgUrl.push(data.file);
      } else {
        this.ImgUrl.push(data.file);
      }
      this.baseFiles = [];
      this.ImgUrl.forEach(async (item) => {
        const res = await this.fileToBase64(item);
        this.baseFiles.push(res);
      });

      let defaultItem = this.ImgUrl.filter(item => {
        return item.isDefault === true
      })[0];

      this.url = defaultItem.url;
      this.urls = this.ImgUrl.map(item => item.url);
    },
    handleSetDefault(data) {
      if (data.isDefault) {
        this.$message.warning("请勿重复设置默认图片！");
        return;
      }
      data.isDefault = true;
      this.url = data.url;
      this.ImgUrl.forEach((item) => {
        if (item.uid === data.uid) return;
        item.isDefault = false;
      });
      this.urls = this.ImgUrl.map(item => item.url)
      this.$message.success("设置默认成功！");
      this.$refs.UnitType.focus();
    },
    nodeSelect(val) {
      this.data.ClassId = val
    },
    getList() {
      this.classApi.list({ ClassType: 1 }).then((res) => {
        this.classList = res.Data;
        // console.log("分类");
        // console.log(this.classList);
      });
      this.valuationApi.list({}).then((res) => {
        this.valuationList = res.Data;
        // console.log("计价方式");
        // console.log(this.valuationList);
      });
      this.productTypeApi.list({}).then((res) => {
        this.productTypeList = res.Data;
        // console.log("类型");
        // console.log(this.productTypeList);
      });
      this.mouldApi.list({ Statuses: [1, 2] }).then((res) => {

        if (res.Code === 0) {
          this.MouldList = res.Data;
          console.log("模具档案", this.MouldList);
          let arr = [];
          let WeightUnitIds = [];
          let length = this.MouldList.length;
          for (let i = 0; i < length; ++i) {
            if (arr.indexOf(this.MouldList[i].WeightUnitId) === -1) {
              arr.push(this.MouldList[i].WeightUnitId);
              let o = {
                MouldId: this.MouldList[i].MouldId,
                WeightUnitId: this.MouldList[i].WeightUnitId,
                WeightUnitName: this.MouldList[i].UnitName,
              }
              WeightUnitIds.push(o)
            }
          }
          console.log('WeightUnitIds', WeightUnitIds)
          WeightUnitIds = WeightUnitIds.filter(item => {
            return item.WeightUnitId != null
          })
          this.WeightUnitIds = WeightUnitIds;
        } else {
          this.$message.error(res.Msg)
        }


      });
      // 可能需要补充参数
      this.tradeUnitApi.list({ TradeUnitTypes: [1, 2, 3] }).then((res) => {
        this.tradeUnitList = res.Data;
        // console.log("默认供应商");
        // console.log(this.tradeUnitList);
      });
      this.warehouseApi.list({}).then((res) => {
        this.warehouseList = res.Data;
        // console.log("默认仓库");
        // console.log(this.warehouseList);
      });
      this.unitApi.list({}).then((res) => {
        this.unitList = res.Data.filter((item) => item.IsGroup == false);

        // console.log("单位");
        // console.log(this.unitList);
      });
      this.unitGroupApi.list({}).then((res) => {
        this.unitGroup = res.Data;
        // console.log("单位组");
        // console.log(this.unitGroup);
      });
    },
    // 打开时获取显示显示列表
    onOpened() {
      this.isEdit = false;
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
      this.getList();
    },
    serialCode() {
      this.code_api.previewNo("产品").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.ProductNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取存货档案编号失败");
        }
      });
    },
    onCreateOpened() {
      const userInfo = localStorage.getItem("loginInfo");
      this.is_moreGroup = false;
      this.data.AddUserId = userInfo.UserId;
      this.data.AddUserName = userInfo.UserName;
      this.data.AddTime = new Date();
      this.serialCode();
    },
    onEditOpened(data) {
      this.isEdit = true;
      const userInfo = localStorage.getItem("loginInfo");
      // 编辑
      this.api.info(data.ProductId).then((res) => {
        this.data = res.Data;
        this.hasGrammage=res.Data.HasGrammage
        this.IsExistStatus = this.data.IsExistProductStock;
        if (res.Data.Property != "劳务") {
          this.isMultiple = true;
          this.Property = res.Data.Property.split(",");
        }
        this.data.UpdateUserId = userInfo.UserId;
        this.data.UpdateUserName = userInfo.UserName;
        this.data.UpdateTime = new Date();
        this.isHasExpire(data.HasExpire);
        if (this.data.UnitType === 0) this.is_moreGroup = false;
        if (this.data.UnitType === 1) {
          this.unitToggle(this.data.UnitType, false);
          this.unitGroupToggle(this.data.UnitGroupId, false);
        }

        this.colorGroup = res.Data.Colors.map((i) => ((i.T = 3), i));

        this.unitGroupList = res.Data.Units.map((i) => ((i.T = 3), i));

        let isMainItem = this.unitGroupList.filter(item => {
          return item.IsMain === true;
        })[0]
        this.unitGroupList.forEach((item) => {
          if (!item.IsMain) {
            item.RateDescription = `1${item.UnitName}=${item.Rate}${isMainItem.UnitName}`
          }
        });


        this.Rubbers = res.Data.Rubbers.map((i) => ((i.T = null), i));
        if (this.Rubbers && this.Rubbers.length !== 0) {
          this.Rubbers.forEach(item => {
            this.$set(item, 'IsDefault', false)
          })
          let item = this.Rubbers.filter(item => item.MouldId === this.data.MouldId)[0]; // 获取默认模具的对象
          item.IsDefault = true;
        }


        console.log("this.unitGroupList", this.unitGroupList);

        // if (data.ImgUrl && data.ImgUrl != "") {
        //   data.ImgUrl.split(",").forEach((e) => {
        //     // this.ImgUrl.push({
        //     //   url: e,
        //     // });
        //     this.ImgUrl.push({
        //       url
        //     });
        //   });
        //   // console.log('编辑图片');
        //   // console.log(this.ImgUrl);
        // }

        if (this.data.Imgs && this.data.Imgs.length > 0) {
          this.data.Imgs = this.data.Imgs.filter((item) => item.ImgUrl);
          this.ImgUrl = this.data.Imgs.map((item) => {
            let o = this.base64ToFile(item.ImgUrl);
            o.T = 1;
            o.ProductImgId = item.ProductImgId;
            o.ProductId = item.ProductId;
            o.isDefault = item.IsDefault;
            o.url = this.fileToBlob(o);
            return o;
          });
          this.ImgUrl.forEach(async (item) => {
            const res = await this.fileToBase64(item);
            this.baseFiles.push(res);
          });
          this.url = this.data.ImgUrl;
          this.urls = this.data.Imgs.map(item => item.ImgUrl)
        }
        // this.areaList = res.Data.DetailDtos.reduce((arr, item) => {
        //   arr.push({ RegionId: item.RegionId, Name: item.Name });
        //   return arr;
        // }, []);
        // this.data = res.Data;
      });
    },
    mainUnitToggle(data, index) {
      if (data) {
        // if (this.is_UnitSaved) {
        //   this.data.Units = this.PreUnits;
        //   this.is_UnitSaved = false;
        // }
        if (this.unitGroupList[index].T === 3) this.unitGroupList[index].T = 1;
        let list = this.unitGroupList
          .map((v) => v.IsMain)
          .filter((item) => item == true);
        if (list.length >= 2) {
          this.$message.warning("主计量只能单选");
          this.unitGroupList[index].IsMain = false;
        }
      }
    },
    // 设置默认模具
    setMouldDefault(row) {
      // 将模具信息设置到基础信息中的模具相关字段里
      let { MouldId, PerGrossWeightUnitId, PerGrossWeight, PerNetWeight, IsDefault } = row;

      this.data.MouldId = MouldId;
      this.data.WeightUnitId = PerGrossWeightUnitId;
      this.data.GrossWeight = PerGrossWeight;
      this.data.NetWeight = PerNetWeight;

      this.Rubbers.forEach(item => {
        item.IsDefault = false;
      });
      row.IsDefault = true;


    },
    // 模具多选
    handleMouldChange(list) {
      this.selectMouldList = list
    },
    // 批量删除模具
    delMould() {
      if (this.ProduceTypeName === "" && (this.Property.length === 0 || this.Property === "")) {
        this.$message.error('请先选择存货类型和存货属性')
        return
      }

      if (this.selectMouldList.length === 0) {
        this.$message.error('请选择要删除的模具');
        return
      }

      // 如果删除中有默认模具的，不允许删除，先设置其他默认模具
      let defaultMould = this.selectMouldList.filter(item => item.IsDefault === true)
      if (defaultMould.length !== 0) {
        this.$message.error('删除的模具中不能包含默认模具');
        return
      }


      let length = this.selectMouldList.length;
      let deleteMouldList = [];
      for (let i = 0; i < length; ++i) {
        let index = this.Rubbers.findIndex(item => {
          return item.MouldId === this.selectMouldList[i].MouldId;
        })
        if (this.selectMouldList[i].T !== 0) {
          this.selectMouldList[i].T = 2;
          deleteMouldList.push(this.selectMouldList[i]);
        }
        this.Rubbers.splice(index, 1)
      }

      this.deleteMouldList = deleteMouldList;

    },
    // 添加模具
    addMould() {

      if (this.ProduceTypeName === "" && (this.Property.length === 0 || this.Property === "")) {
        this.$message.error('请先选择存货类型和存货属性')
        return
      }

      let o = {
        T: 0,
        IsDefault: false,
        MouldId: 0,
        MouldName: '',
        MouldNo: '',
        Afew: null,
        Quantity: null,
        Weight: null,
        PerGrossWeightUnitName: '',
        PerGrossWeightUnitId: 0,
        PerGrossWeight: null,
        PerNetWeight: null,
        Sn: null,
      }
      this.Rubbers.push(o)
    },
    // 修改表格T标志
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },
    // 模具名变动，赋值给其他相关字段
    changeMouldName(val, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      let item = this.MouldList.filter(item => {
        return item.MouldId === val
      })[0];

      row.MouldId = item.MouldId
      row.MouldNo = item.MouldNo;
      row.Afew = item.Afew;
      row.PerGrossWeightUnitId = item.PerGrossWeightUnitId;
      row.PerGrossWeightUnitName = item.PerGrossWeightUnitName;
      row.PerGrossWeight = item.PerGrossWeight
      row.PerNetWeight = item.PerNetWeight
      row.Sn = item.Sn


    },
    // 存货类型为胶件，则启用特殊工序为空，让用户自己选，否则默认为否
    changeProductType(val) {

      let item = this.productTypeList.filter(item => {
        return val === item.ProductTypeId;
      })[0];

      this.ProduceTypeName = item.ProduceTypeName;
      if (item.ProduceTypeName !== '胶件') {
        this.data.UseProcess = false;
        this.isMouldTabShow = false;
        this.requiredRubbers = false;
      } else {
        this.data.UseProcess = true
        if (this.Property && this.Property.includes("采购")) {
          this.isMouldTabShow = false;
          this.Rubbers = [];
          this.requiredRubbers = false;
        } else if (this.Property && this.Property.includes("加工") && !this.Property.includes("采购")) {
          this.isMouldTabShow = true;
          this.requiredRubbers = true;
        } else {
          this.isMouldTabShow = true;
          this.requiredRubbers = false;
        }
      }

      // if(this.Property &&  this.ProduceTypeName === '胶件' && this.Property.includes("加工") && !this.Property.includes("采购")){
      //   this.isMouldTabShow = true;
      //   this.requiredRubbers = true;
      // }else{
      //   this.requiredRubbers = false;
      // }
    },
    changeProcessStage(val) {
      if (val == 1) {
        this.data.UseProcess = true
      } else {
        this.data.UseProcess = false;
      }
    },
    isProperty(data) {

      if (data.includes("劳务") || data == "劳务") {
        this.isMultiple = false;
        this.Property = "劳务";
        return;
      }
      if (data != "劳务") {
        this.isMultiple = true;
        if (!(data instanceof Array)) this.Property = [];
      }
      // 存货属性为采购时，不需要填写模具
      if (this.ProduceTypeName === '胶件') {


        if (data.includes("采购")) {
          this.isMouldTabShow = false;
          this.Rubbers = [];
          this.requiredRubbers = false;
        } else if (data.includes("加工") && !data.includes("采购")) {
          this.isMouldTabShow = true;
          this.requiredRubbers = true;
        } else {
          this.isMouldTabShow = true;
          this.requiredRubbers = false;
        }
      } else {
        this.isMouldTabShow = false;
        this.requiredRubbers = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      //// console.log(this.multipleSelection);
    },
    clearSelect() {
      this.data.RpUnitId = null;
      this.data.SkUnitId = null;
      this.data.PuUnitId = null;
      this.data.SaUnitId = null;
      this.data.PdUnitId = null;
    },
    singToggle(data) {
      console.log("singToggle", data);
      if (this.data.UnitType === 0) {
        this.data.RpUnitId = data;
        this.data.SkUnitId = data;
        this.data.SaUnitId = data;
        this.data.PdUnitId = data;
        this.data.PuUnitId = data;
      }
    },
    unitToggle(data, isClear = true) {
      console.log("data", data);
      if (data === 0) {
        this.is_moreGroup = false;
        this.unitApi.list({}).then((res) => {
          this.unitGroupList = [];
          this.data.UnitGroupId = null;
          this.unitList = res.Data.filter((item) => item.IsGroup == false);
          this.clearSelect();
        });
      }
      if (data === 1) {
        this.unitList = [];
        this.data.UnitGroupId = this.data.UnitGroupId !== 0 ? this.data.UnitGroupId : null;
        this.is_moreGroup = true;
        if (isClear) this.clearSelect();
      }
    },
    upDateRate(data, $index, row) {
      row.Rate = parseFloat(data)
      if (this.unitGroupList[$index].T === 3) this.unitGroupList[$index].T = 1;

      let isMainItem = this.unitGroupList.filter(item => {
        return item.IsMain === true;
      })[0]
      console.log('isMainItem', isMainItem)
      row.RateDescription = `1${row.UnitName}=${row.Rate}${isMainItem.UnitName}`
    },
    unitGroupToggle(data, isClear = true) {
      this.unitApi
        .list({ UnitGroupId: data })
        .then((res) => {
          // this.data.UnitType = 1;
          this.unitList = res.Data;

          if (isClear) {
            // const unitGroups = this.unitGroup.filter(
            //   (item) => item.UnitGroupId == data
            // );
            this.is_showUnitGroup = false;
            this.unitGroupList = res.Data;
            let mainUnits = [];
            let notMainUnits = [];
            let isMainItem = this.unitGroupList.filter(item => {
              return item.IsMainUnit === true;
            })[0]
            console.log('isMainItem', isMainItem)
            this.unitGroupList.forEach((item) => {
              item.IsMain = item.IsMainUnit;
              this.$set(item, "Rate", item.ChangeRate);
              if (item.IsMain) {
                mainUnits.push(item)
              } else {
                item.RateDescription = `1${item.UnitName}=${item.Rate}${isMainItem.UnitName}`
                notMainUnits.push(item)
              }
              // item.Rate=item.ChangeRate
            });
            console.log('this.unitGroupList', this.unitGroupList)
            this.is_showUnitGroup = true;
            this.clearSelect();
            this.data.SkUnitId = mainUnits[0].UnitId;
            this.data.RpUnitId = notMainUnits[0]?.UnitId
          }
        })
        .catch(() => {
          this.data.UnitGroupId = null;
        });
    },
    getAfew(data) {
      console.log("data", data);
      this.data.MouldRubberId = data.Afew;
    },
    isHasExpire(data) {
      if (data == true) {
        this.isExpireDay = true
        // this.$refs.dialog.$refs.form.validateField('ExpireDay')
        return
      }
      if (data == false) {
        this.data.ExpireDay = null;
        this.$refs.dialog.$refs.form.clearValidate('ExpireDay')
        this.isExpireDay = false;
      }
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    // beforePhotoUpload(file) {
    //   this.headers.Authorization = "Bearer " + localStorage.getItem("token");
    // },
    masterFileMax(files, fileList) {
      this.$message.warning(`请最多上传 3 张图片。`);
    },
    // onSuccess(res, name) {
    //   console.log(res);
    //   // if (res.Code == 0) {
    //   //   //// console.log(this.$refs.uploadImg);
    //   //   // let host = window.location.origin;
    //   //   this.ImgUrl.push({ url: "/api" + res.Data });
    //   // } else {
    //   //   this.$message.error(res.Msg);
    //   // }
    // },
    picRemove(file) {
      const findIndex = this.ImgUrl.findIndex((item) => item.uid == file.uid);
      const flag = this.ImgUrl[findIndex].isDefault;
      if (file.T == 0) {
        this.ImgUrl.splice(findIndex, 1);
      } else {
        this.removeImgUrl.push(this.ImgUrl.splice(findIndex, 1)[0]);
      }
      if (flag && this.ImgUrl.length > 0) {
        this.ImgUrl[0].isDefault = true;
      }
      this.baseFiles = [];
      this.ImgUrl.forEach(async (item) => {
        const res = await this.fileToBase64(item);
        this.baseFiles.push(res);
      });
      // this[name].forEach((e, i) => {
      //   if (e.url == file.url) return this[name].splice(i, 1);
      // });
    },
    onBeforeSave() {
      if (this.ImgUrl.length === 0) {
        this.data.Imgs = [];
      } else {
        this.data.Imgs = this.ImgUrl.map((item, index) => {
          return {
            T: item.T,
            ProductImgId: item.ProductImgId,
            ProductId: item.ProductId,
            ImgUrl: this.baseFiles[index],
            IsDefault: item.isDefault,
          };
        });
      }
      if (this.isEdit) {
        this.removeImgUrl.forEach((item) => {
          item.T = 2;
          item.isDefault = false;
          this.data.Imgs.push(item);
        });
        this.removeImgUrl = [];
      }
      //// console.log('我的')
      //// console.log(this.data.ImgUrl);

      // 颜色组
      console.log("Colors", this.data.Colors);
      console.log("colorGroup", this.colorGroup);
      // this.data.Colors = []

      if (this.data.Colors.length !== 0) {
        // if(this.is_ColorSaved){
        //    this.data.Colors = this.PreColor;
        //    this.colorGroup = this.PreColorGroup
        // }
        // this.is_ColorSaved = true;
        // this.PreColor = JSON.parse(JSON.stringify(this.data.Colors))
        // this.PreColorGroup = JSON.parse(JSON.stringify(this.colorGroup))
        let delIds = this.colorGroup.map((item) => item.ColorId);
        let delList = this.data.Colors.reduce((arr, item) => {
          if (!delIds.includes(item.ColorId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);
        let addIds = this.data.Colors.map((item) => item.ColorId);
        let addList = [];
        addList = this.colorGroup.reduce((arr, item) => {
          if (!addIds.includes(item.ColorId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);
        this.data.Colors = [...addList, ...delList];
      } else {
        //  if (this.colorGroup.length === 0) return;
        this.data.Colors = JSON.parse(JSON.stringify(this.colorGroup));
      }

      // 单位列表
      if (this.data.Units.length !== 0) {
        // if(this.is_UnitSaved){
        //   this.data.Units = this.PreUnits;
        //   this.unitGroupList = this.PreUnitGroupList;
        // };
        // this.is_UnitSaved = true;
        // this.PreUnits = JSON.parse(JSON.stringify(this.data.Units));
        // this.PreUnitGroupList = JSON.parse(JSON.stringify(this.unitGroupList));

        let unitDelIds = this.unitGroupList.map((item) => item.UnitId);
        let unitDelList = this.data.Units.reduce((arr, item) => {
          if (!unitDelIds.includes(item.UnitId)) arr.push({ ...item, T: 2 });
          return arr;
        }, []);

        let unitUpdateList = this.unitGroupList.filter((i) => i.T === 1);

        let unitAddIds = this.data.Units.map((item) => item.UnitId);
        let unitAddList = [];
        unitAddList = this.unitGroupList.reduce((arr, item) => {
          if (!unitAddIds.includes(item.UnitId)) arr.push({ ...item, T: 0 });
          return arr;
        }, []);

        this.data.Units = [
          ...unitAddList,
          ...unitDelList,
          ...unitUpdateList,
        ].filter((i) => i.T !== 3);
      } else {
        // if (this.unitGroupList.length === 0) return;
        this.data.Units = this.unitGroupList.reduce((arr, item) => {
          arr.push({ ...item, UnitName: item.Name });
          return arr;
        }, []);
      }

      //模具列表


      // 将模具列表深拷贝到this.data里
      this.data.Rubbers = [];
      let _Rubbers = this.Rubbers.filter(item => item.T != null)
      this.data.Rubbers = JSON.parse(JSON.stringify(_Rubbers))

      //将删除的模具列表也添加进去
      this.deleteMouldList.forEach(item => {
        this.data.Rubbers.push(item)
      })

    },
    add() {
      this.$refs.colorDialog.open().then((that) => {
        that.getData();
      });
    },
    del() {
      if (this.multipleSelection.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let delList = this.multipleSelection.map((item) => item.ColorId);
          let data = this.colorGroup.filter(
            (item) => !delList.includes(item.ColorId)
          );
          this.colorGroup = JSON.parse(JSON.stringify(data));
        })
        .catch(() => { });
    },
    setColor(data) {
      //// console.log("颜色组");
      //// console.log(data);
      //// console.log(this.data.Colors);
      // if (this.is_ColorSaved) {
      //   this.data.Colors = this.PreColor;
      //   this.is_ColorSaved = false;
      // }
      console.log("color data", JSON.parse(JSON.stringify(data)));
      let areaId = this.colorGroup.map((item) => item.ColorId);
      data.forEach((item) => {
        if (!areaId.includes(item.ColorId)) {
          this.colorGroup.push({
            ColorId: item.ColorId,
            ClassName: item.ClassName,
            ColorName: item.ColorName,
            ClassNo: item.ClassNo,
            Sn: item.Sn,
            Status: item.Status,
            T: 0,
          });
        }
      });

      //// console.log(this.data.Colors)
    },
    toSave(t) {
      console.log("data", this.data.Colors);
      this.data.Property =
        this.Property instanceof Array
          ? this.Property.toString()
          : this.Property;
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        if (
          this.data.UnitType === 1 &&
          this.unitGroupList.filter((i) => i.IsMain === true).length !== 1
        ) {
          this.$message.warning("单位主计量单位有且只有一个");
          return false;
        }


        // 验证模具列表是否必填
        if (this.requiredRubbers && this.Rubbers.length === 0) {
          this.$message.error('请先填写模具列表')
          return false
        }

        //模具列表不为空，验证记录是否全部填写
        if (this.Rubbers.length !== 0) {
          let length = this.Rubbers.length;
          for (let i = 0; i < length; ++i) {
            if (this.Rubbers[i].MouldId == 0) {
              this.$message.error('模具列表有记录未选择模具');
              return false;
            }
            if (this.Rubbers[i].Quantity == null) {
              this.$message.error('模具列表有记录未填写数量');
              return false;
            }
            if (this.Rubbers[i].Weight == null) {
              this.$message.error('模具列表有记录未填写单重');
              return false;
            }
          }
        }

        if (this.Rubbers.length !== 0 && this.data.MouldId == null) {
          this.$message.error('模具列表请设置默认模具');
          return false;
        }


        const pre_colors = JSON.parse(JSON.stringify(this.data.Colors));
        console.log("pre_colors", pre_colors);
        // if (this.data.UseColor && this.colorGroup.length === 0) {
        //   this.$message.warning("选择启用颜色，请添加颜色列表项");
        //   return false;
        // }
        const pre_units = JSON.parse(JSON.stringify(this.data.Units));
        const pre_Rubbers = JSON.parse(JSON.stringify(this.data.Rubbers));

        this.onBeforeSave();
        var data = this.$commonJs.obj.removeNullKey(this.data);
        //ProductSpec 规格型号
        // data.ProductSpec?data.ProductSpec:''
        if (!data.ProductSpec) data.ProductSpec = "";
        this.api.save(data).then((res) => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.close(1);
            this.$emit("close-saved");
            this.data.Imgs = [];
          } else {
            this.data.Colors = pre_colors;
            this.data.Units = pre_units;
            this.data.Rubbers = pre_Rubbers;

            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.ImgUrl = [];
      this.showList = [];
      this.MouldList = [];
      this.tradeUnitList = [];
      this.unitList = [];
      this.warehouseList = [];
      this.classList = [];
      this.valuationList = [];
      this.productTypeList = [];
      this.data.Colors = [];
      this.unitGroup = [];
      this.multipleSelection = [];
      this.colorGroup = [];
      this.Rubbers = [];
      this.data.Rubbers = [];
      this.unitGroupList = [];
      this.Property = null;
      this.IsExistStatus = false;
      this.url = "";
      this.urls = [];
      this.deleteMouldList = [];
      // this.PreColor = [];
      // this.PreUnits = [];
      // this.PreUnitGroupList = [];
      // this.PreColorGroup = [];
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}

/deep/ .rate .el-input__inner {
  text-align: center;
}
/deep/ .el-dialog__header {
  height: 40px;
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
